<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="epi"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span aria-label="9" id="pg_9" role="doc-pagebreak">The major advances in civilization are processes that all but wreck the societies in which they occur.… It is the business of the future to be dangerous; and it is among the merits of science that it equips the future for its duties.</span></p>
<p class="FM-Epigraph-Source-fmeps">—Alfred North Whitehead</p>
<p class="FM-Epigraph-verse-fmepiv">The brain is wider than the sky</p>
<p class="FM-Epigraph-verse-fmepiv">For, put them side by side</p>
<p class="FM-Epigraph-verse-fmepiv">The one the other will contain</p>
<p class="FM-Epigraph-verse-fmepiv">With ease, and you beside.</p>
<p class="FM-Epigraph-Source-fmeps">—Emily Dickinson</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?a95c6668